module.exports = __webpack_public_path__ + "img/text-resize.5d239655.svg";